export default "__VITE_ASSET__hshQS0le__"